import React from "react";
import { formatHandicapLabel, formatUnixToVNDate } from "@/utils/format";
import {
  LIVE_STATUSES,
  FINISHED_STATUSES,
  NOT_STARTED_STATUS,
} from "@/contants";

export default function CarouselMatch({ match }) {
  const statusNum = Number(match.status);
  const isLive = LIVE_STATUSES.includes(statusNum);
  const isFinished = FINISHED_STATUSES.includes(statusNum);
  const isNotStarted = NOT_STARTED_STATUS.includes(statusNum);

  const { date: formattedDate, thu: formattedThu, gio: formattedGio } = formatUnixToVNDate(match.matchTime);

  const handicapOdds = match.handicapOdds?.[0];
  const handicapValue = handicapOdds?.initialHandicap || handicapOdds?.instantHandicap || "";
  const homeHandicapOdds = handicapOdds?.initialHome || handicapOdds?.instantHome || "";
  const awayHandicapOdds = handicapOdds?.initialAway || handicapOdds?.instantAway || "";

  const overUnderOdds = match.overUnderOdds?.[0] || match.odd?.overUnderOdds?.[0];
  const overUnderValue = overUnderOdds?.initialOverUnder || overUnderOdds?.instantOverUnder || "2.50";
  const overOdds = overUnderOdds?.initialOver || overUnderOdds?.instantOver || "";
  const underOdds = overUnderOdds?.initialUnder || overUnderOdds?.instantUnder || "";

  return (
    <div className="w-full min-w-[300px] bg-white rounded-lg border border-[var(--theme-border)] pt-1 flex flex-col gap-3">
      <div className="flex items-center justify-between px-3">
        <span className="text-sm font-medium">
          {formattedGio} - {formattedDate} ({formattedThu})
        </span>
      </div>

      <div className="flex flex-col gap-1 px-3">
        <div className="flex items-center gap-1">
          {match.homeTeam?.logo && (
            <img
              src={match.homeTeam.logo}
              alt={match.homeName}
              width={24}
              height={24}
              className="rounded-full"
            />
          )}
          <span className="text-sm text-[var(--theme-text)]">
            {match.homeName}
          </span>
        </div>
        <div className="flex items-center gap-1">
          {match.awayTeam?.logo && (
            <img
              src={match.awayTeam.logo}
              alt={match.awayName}
              width={24}
              height={24}
              className="rounded-full"
            />
          )}
          <span className="text-sm text-[var(--theme-text)]">
            {match.awayName}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 bg-[var(--theme-bg)] px-3 py-1">
        <div className="flex flex-col gap-2">
          <span className="text-xs text-[var(--theme-text-muted)] font-medium">Cược chấp</span>
          <div className="flex flex-col gap-1.5">
            <div className="flex items-center gap-2 bg-[var(--theme-foreground)]">
              <div className="px-2 py-1 rounded text-xs text-gray-700 min-w-[40px] text-center">
                {formatHandicapLabel(handicapValue, true)}
              </div>
              <span className="text-sm font-medium text-[var(--theme-text)] ml-auto">
                {homeHandicapOdds || "-"}
              </span>
            </div>
            <div className="flex items-center gap-2 bg-[var(--theme-foreground)]">
              <div className="px-2 py-1 rounded text-xs text-gray-700 min-w-[40px] text-center">
                {formatHandicapLabel(handicapValue, false)}
              </div>
              <span className="text-sm font-medium text-[var(--theme-text)] ml-auto">
                {awayHandicapOdds || "-"}
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <span className="text-xs text-[var(--theme-text-muted)] font-medium">Tài/Xỉu</span>
          <div className="flex flex-col gap-1.5">
            <div className="flex items-center gap-2 bg-[var(--theme-foreground)]">
              <div className="px-2 py-1 rounded text-xs text-gray-700 min-w-[40px] text-center">
                {overUnderValue || "2.50"}
              </div>
              <span className="text-sm font-medium text-[var(--theme-text)] ml-auto">
                {overOdds || "-"}
              </span>
            </div>
            <div className="flex items-center gap-2 bg-[var(--theme-foreground)]">
              <div className="px-2 py-1 rounded text-xs text-gray-700 min-w-[40px] text-center">
                U
              </div>
              <span className="text-sm font-medium text-[var(--theme-text)] ml-auto">
                {underOdds || "-"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
